export interface SegmentedDot {
  segmentId: string;
  color: string;
  score: number;
  isFadedOut: boolean;
}

export const getFadedSegments = (scores: number | SegmentedDot[]) => {
  if (Array.isArray(scores)) {
    return new Set(
      scores.filter((dot) => dot.isFadedOut).map((dot) => dot.segmentId),
    );
  }
  return undefined;
};

export const getDots = (scores: number | SegmentedDot[], color: string) => {
  if (Array.isArray(scores)) {
    return scores.flatMap((dot) =>
      Array.from({ length: dot.score }, (_, i) => ({
        id: `${dot.segmentId}-dot-${i}`,
        x: 0,
        y: 0,
        color: dot.color,
        segmentId: dot.segmentId,
      })),
    );
  }
  return Array.from({ length: scores }, (_, i) => ({
    id: `dot-${i}`,
    x: 0,
    y: 0,
    color,
  }));
};
